import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContextMenuItem, DisplayColour } from '../context-menu-item';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss']
})
export class ContextMenuComponent implements OnInit {

  @Input()
  menuItems : ContextMenuItem[] = [];

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  public itemClicked(menuItem: ContextMenuItem): void {
    // Prevent action if item is disabled
    if (menuItem.disabled) {
      return;
    }

    if (menuItem.actionType == 'link') {
      this.router.navigate([menuItem.href]);
    } else {
      menuItem.onClick();
    }
  }
}
